import type { ApiError, Identifiable } from '@empathyco/playboard-core-domain'

import type { FacetsInfoDto } from '../models'

import type { FacetsInfoAdapter } from './interfaces'

import { injectable } from 'inversify'

export interface PlatformFacetsInfoEntity extends Identifiable {
  facet: string
  instance: string
  criteria?: PlatformFacetsInfoCriteriaDTO[]
  metadata?: PlatformFacetsInfoMetadataDTO[]
}

interface PlatformFacetsInfoCriteriaDTO {
  key: string
  values: string[]
}

interface PlatformFacetsInfoMetadataDTO {
  key: string
  value: string
}

export interface PlatformFacetsInfoError {
  status: number
  data: {
    code: string
    error: string
  }
}
@injectable()
export class PlatformFacetsInfoAdapter
  implements FacetsInfoAdapter<PlatformFacetsInfoEntity, PlatformFacetsInfoError>
{
  decode(payload: PlatformFacetsInfoEntity): FacetsInfoDto {
    const { id, facet, instance, criteria, metadata } = payload ?? {}

    return {
      id,
      facet,
      instance,
      criteria,
      metadata,
    }
  }

  decodeError(error: PlatformFacetsInfoError): ApiError<unknown> {
    return {
      status: error.status,
      message: error.data.error,
    }
  }

  encode(payload: FacetsInfoDto): PlatformFacetsInfoEntity {
    const { id, facet, instance, criteria, metadata } = payload

    return {
      id,
      facet,
      instance,
      criteria,
      metadata,
    }
  }
}
